export default (term_data, terms) => {
    let id = term_data.id ? term_data.id : term_data;
    let term_match = terms.nodes.find((a_term) => {
        return a_term.drupal_id == id
    })
    return term_match;
}